import { Button } from "components/Button/Button";
import { useState } from "react";
import { trans } from "utils/helpers";
import './style.scss'

interface AcceptSelfServiceProps {
    handleAcceptReferenceAsync? : (a?:any) =>void;
    onHide? : (e:any) => void;
    isAccepted?:any
   
}

export const AcceptSelfService = ({isAccepted =false, onHide,handleAcceptReferenceAsync}:AcceptSelfServiceProps) => {
    return ( 
      <div className={`${!isAccepted?'AcceptContext' : 'NonAcceptContext'} mb-3`}>
        <div className="AcceptTitle" >
             {/* <button onClick={(e)=>{onHide && onHide(e)}} type="button" className="closeBtn border-none alert-primary">
                 <span aria-hidden="true">&times;</span>
             </button> */}

             <div className="AcceptMassage">
                 {trans(!isAccepted?"Msg_DoYouWantToAcceptTheTask":"msg_doyouwanttoacceptcancelthetask")}
             </div>
         </div>
         <div>
             <Button
              btnType={`${!isAccepted?'primaryFill':'cancelFill'}`}
              value={`${!isAccepted?'accept':'acceptcancel'}`}
              onClick={() =>{handleAcceptReferenceAsync && handleAcceptReferenceAsync( !isAccepted? true:false)}}
             />

         </div>
      </div>
     );
}